import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryCard = ({ category, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`
        flex flex-col items-center justify-center gap-2 md:gap-3
        p-4 md:p-6 lg:p-8
        rounded-xl md:rounded-2xl
        transition-all duration-250
        ${isActive 
          ? 'bg-primary text-primary-foreground shadow-organic-lg' 
          : 'bg-card hover:bg-muted border border-border'
        }
      `}
      style={{
        minHeight: '120px'
      }}
    >
      <div className={`
        w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16
        rounded-full
        flex items-center justify-center
        ${isActive ? 'bg-primary-foreground/20' : 'bg-primary/10'}
      `}>
        <Icon 
          name={category?.icon} 
          size={24}
          color={isActive ? 'currentColor' : 'var(--color-primary)'}
        />
      </div>
      <div className="text-center">
        <h3 className={`
          font-semibold
          text-sm md:text-base lg:text-lg
          ${isActive ? 'text-primary-foreground' : 'text-foreground'}
        `}>
          {category?.name}
        </h3>
        <p className={`
          text-xs md:text-sm
          ${isActive ? 'text-primary-foreground/80' : 'text-muted-foreground'}
        `}>
          {category?.count} ürün
        </p>
      </div>
    </button>
  );
};

export default CategoryCard;